import React from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import moment from 'moment'
import { Box, Flex } from 'grid-styled'

import { setNewDueDate, lockAuthorizationPayment } from 'alelo-logic/actions'
import { setLoading } from '../../modules/PageLoader/actions'

import ImersiveHeader from '../../elements/ImersiveHeader'
import Icon from 'app/elements/Icon/Icon'
import DueDateForm from '../../modules/DueDateForm'
import { showModal } from '../../modules/ModalRoot/actions'
import { CONFIRM_UPDATE } from '../../../constants/ModalTypes'

import image from '../../../static/confirmation.png'
import Content from '../../../styles/objects/Content'
import { Notice } from './styles'
import { titleModalError, bodyModalError, titleModalSuccess, bodyModalSuccess } from './data.json'

const EditDueDate = props => {
  const onSubmit = values => {
    const {
      updateDueDate,
      setBlockChangeDueDate,
      showSuccessModal,
      showErrorModal,
      location: { state: { currentPlan } }
    } = props

    return new Promise((resolve, reject) => {
      if (values.dataFatura) {
        const data = { idConta: currentPlan.accountId, diaVenctoSolicitado: values.dataFatura }
        updateDueDate(data)
          .then(async () => {
            await setBlockChangeDueDate()
            showSuccessModal()
            resolve()
            props.history.goBack()
          })
          .catch(err => {
            console.error(err)
            showErrorModal()
            return reject(err)
          })
      }
    })
  }

  const ableToChangeDueDate =
    props.authorizations.DATA &&
    !props.authorizations.DATA.dataProximaAlteracao &&
    !props.authorizations.DATA.error
  const daysToChangeDueDate = !ableToChangeDueDate
    ? moment(props.authorizations.DATA.dataProximaAlteracao, 'DD/MM/YYYY').diff(moment(), 'days') +
      1
    : null

  return (
    <Flex direction="column">
      <Helmet title="Editar data de vencimento" />
      <Box>
        <ImersiveHeader text="Dados do plano" back={() => props.history.goBack()} />
      </Box>
      <Content>
        <Box width={[1, 480]} mt={24}>
          <Notice>
            <Icon height={14} icon="alert" viewBox="0 0 16 13" display="flex" />
            {!ableToChangeDueDate ? (
              props.authorizations.DATA.error && props.authorizations.DATA.description ? (
                <span>{props.authorizations.DATA.description}</span>
              ) : (
                <span>
                  Você fez uma alteração de vencimento recentemente. <br />Em{' '}
                  <b>{daysToChangeDueDate}</b> dia{daysToChangeDueDate > 1 ? 's' : ''} você poderá
                  fazer uma nova alteração.
                </span>
              )
            ) : (
              <span>
                Você só pode alterar a data de vencimento uma vez a cada <b>90 dias</b>.
              </span>
            )}
          </Notice>
        </Box>
        <Box width={[1, 680]}>
          <DueDateForm
            ableToChangeDueDate={ableToChangeDueDate}
            onSubmit={onSubmit}
            dueDates={props.location.state.dueDates}
            handleBackClick={() => props.history.goBack()}
          />
        </Box>
      </Content>
    </Flex>
  )
}

const mapStateToProps = ({ reducer }) => ({
  authorizations: reducer.planData.authorizations
})

const mapDispatchToProps = dispatch => ({
  showSuccessModal: () =>
    dispatch(
      showModal(CONFIRM_UPDATE, {
        modalTitle: titleModalSuccess,
        modalDescription: bodyModalSuccess,
        image
      })
    ),
  showErrorModal: () =>
    dispatch(
      showModal(CONFIRM_UPDATE, {
        modalTitle: titleModalError,
        modalDescription: bodyModalError,
        image
      })
    ),
  updateDueDate: data => dispatch(setNewDueDate(data)),
  setBlockChangeDueDate: () => dispatch(lockAuthorizationPayment('DATA')),
  setLoading: isLoading => {
    dispatch(setLoading(isLoading))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(EditDueDate)



// WEBPACK FOOTER //
// ./src/app/pages/EditDueDate/index.js